import CustomAxios from '../../CustomAxios/CustomAxios';

export const getCurrentStatsAPI = () => {
  return CustomAxios.get(`${process.env.REACT_APP_STATS_URL}/dev/latest`);
};